import { render, staticRenderFns } from "./AdminLhDashboard.vue?vue&type=template&id=52bf5a90"
import script from "./AdminLhDashboard.vue?vue&type=script&lang=js"
export * from "./AdminLhDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports